export const applyTooltipDisabled = (visualization, report) => {
  const tooltipDisabled = report.getIn(['displayParams', 'tooltipDisabled']);
  return tooltipDisabled ? visualization.setIn(['style', 'tooltipDisabled'], tooltipDisabled) : visualization;
};